import { Overline } from './Overline';
import { Reveal } from './Reveal';

export const PageHero = ({ overline, title, intro, titleClassName = 'max-w-2xl', introClassName = 'max-w-lg' }) => (
  <Reveal>
    <Overline>{overline}</Overline>
    <h1 className={`mt-4 text-4xl font-bold tracking-tighter text-silver sm:text-5xl ${titleClassName}`}>
      {title}
    </h1>
    {intro && (
      <p className={`mt-8 text-base leading-relaxed text-steel-light ${introClassName}`}>
        {intro}
      </p>
    )}
  </Reveal>
);
